import { CogniteClient } from '@cognite/sdk';

/**
 * Defines optional metadata for telemetry, such as the browser type.
 */
export type TelemetryMetadata = {
  browser?: string;
};

/**
 * The frontend application environment.
 */

export enum Environment {
  Production = 'production',
  Staging = 'staging',
  Development = 'development',
}

export type TelemetryBaseProps = {
  client: CogniteClient;
  /**
   * Service name where the telemetry data should be published.
   */
  serviceName: string;
  /**
   * Name of the application.
   */
  appName: string;
  metadata?: TelemetryMetadata;
  /**
   * Enable debug mode to log metrics to the console.
   * @default false.
   */
  debug?: boolean;

  /**
   * The environment in which the application is running (e.g., production, staging).
   * @example staging
   */
  environment?: Environment;
};

/**
 * Properties to initialize a telemetry metrics instance.
 */
export type TelemetryMetricsProps = TelemetryBaseProps & {
  /**
   * The interval in milliseconds at which metrics should be exported.
   * @default 10000ms.
   */
  exportIntervalMillis?: number;
};
